import { render, staticRenderFns } from "./PO.vue?vue&type=template&id=12c1670c&scoped=true&"
import script from "./PO.vue?vue&type=script&lang=js&"
export * from "./PO.vue?vue&type=script&lang=js&"
import style0 from "./PO.vue?vue&type=style&index=0&id=12c1670c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1670c",
  null
  
)

export default component.exports